import { z } from "zod";
import { PublicUserSchema } from "../users/public-user.js";
export const refreshSchema = z.object({
    refreshToken: z.string().min(1),
});
export const logoutSchema = z.object({
    refreshToken: z.string().min(1),
});
export const authSessionSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    user: PublicUserSchema,
});
